import uploadshomefeatures06feature01ImagepexelsPhoto111704991293wC500Webp from "$lib/data/generated/uploads/home/Features 06/Feature 01 Image/pexels-photo-11170499-1293w-c500.webp";

export const uploads = {
  "uploads/home/Features 06/Feature 01 Image/pexels-photo-11170499-1293w-c500.webp": uploadshomefeatures06feature01ImagepexelsPhoto111704991293wC500Webp
};